<template>
  <el-row align="middle" v-loading.fullscreen.lock="fullscreenLoading">
    <el-space>
      <div
        style="
          margin-right: 15px;
          cursor: pointer;
          display: flex;
          align-items: center;
        "
        @click="goToDoList"
      >
        <el-space v-if="userInfo?.mct_type !== 3">
          <el-icon size="20" color="#798098">
            <Warning />
          </el-icon>
          <el-badge
            :value="Number(sysToDoListNumber)"
            :max="99"
            :hidden="sysToDoListNumber == 0"
          >
            {{ $t("headerModules.todo") }}
          </el-badge>
        </el-space>
      </div>
      <div
        style="
          margin-right: 15px;
          cursor: pointer;
          display: flex;
          align-items: center;
        "
        @click="toNotice"
        v-if="userInfo?.mct_type !== 3"
      >
        <el-space>
          <img src="./icons/inform.png" style="width: 20px; height: 20px" />
          <el-badge
            :value="Number(sysNoticeLogNumber)"
            :max="99"
            :hidden="sysNoticeLogNumber == 0"
          >
            {{ $t("headerModules.msgNot") }}
          </el-badge>
        </el-space>
      </div>
      <el-dropdown :trigger="['click']" v-model="visible">
        <el-space class="inform" @click="downloadClick">
          <img src="./icons/download.png" style="width: 20px; height: 20px" />
          {{ $t("headerModules.downloadCache") }}
        </el-space>

        <template #dropdown>
          <section
            style="
              min-width: 600px;
              box-shadow: 0px 0px 2px 2px #eee;
              padding: 16px 24px;
            "
          >
            <h-table
              ref="tableRef"
              vuexNamespace="h-header-right"
              :http="getList"
              :columns="columns"
              :autoRequest="false"
            >
              <template #operation="{ row }">
                <el-space>
                  <el-link
                    type="primary"
                    @click="downloadFile(row)"
                    :disabled="row.status !== 1"
                    >{{ $t("download.down") }}</el-link
                  >
                  <el-link type="primary" @click="deleteClick(row)">{{
                    $t("common.delete")
                  }}</el-link>
                </el-space>
              </template>
              <template #status="{ row }">
                <span v-if="row.status === 0">{{
                  $t("common.exporting")
                }}</span>
                <h-link type="success" v-if="row.status === 1">{{
                  $t("common.exportOk")
                }}</h-link>
                <h-link type="danger" v-if="row.status === 2">{{
                  $t("common.exportNo")
                }}</h-link>
              </template>
            </h-table>
          </section>
        </template>
      </el-dropdown>
      <switch-language></switch-language>
      <el-dropdown placement="bottom" @visible-change="visibleChange">
        <el-space>
            <el-avatar :size="32" :src="userInfo?.logo_url" />
            <span>
              {{ userInfo?.name }}
              <!-- <h-link type="success" v-if="userInfo?.is_manager === 'Y'">（部门负责人）</h-link> -->
            </span>
            <el-icon>
              <CaretBottom />
            </el-icon>
        </el-space>
        <template #dropdown>
          <!-- <el-dropdown-item @click="applyMerchant('/wechat-merchant')" v-if="isDealer">
            微信收款商户号
          </el-dropdown-item>
          <el-dropdown-item @click="applyMerchant('/alipay-merchant')" v-if="isDealer">
            支付宝收款商户号
          </el-dropdown-item> -->
          <el-dropdown-menu>
            <!-- <el-dropdown-item
              @click="applyMerchant('/expense-center/import-subscription')"
              v-if="isDealer"
            >
              {{ $t("headerModules.subscription") }}
            </el-dropdown-item> -->
            <el-dropdown-item
              v-if="userInfo?.root == 1"
              @click="applyMerchant('/expense-center/import-subscription')"
            >
              {{ $t("headerModules.subscription") }}
            </el-dropdown-item>
            <el-dropdown-item
              v-if="userInfo?.root == 1"
              @click="goApplicationManagement()"
            >
              {{ $t("headerModules.applicationManagement") }}
            </el-dropdown-item>
            <!-- <el-dropdown-item
              @click="applyMerchant('/expense-center/import-subscription')"
              v-if="(receiveTypeOneObj.apply_status === 0 && userInfo.biz_type === 1) || userInfo.biz_type === 2"
            >
              {{ $t("headerModules.subscription") }}
            </el-dropdown-item> -->
            <el-dropdown-item v-if="userInfo?.root == 1" @click="router.push('/developer-configuration')">
              {{ $t("headerModules.developerConfig") }}
            </el-dropdown-item>
            <el-dropdown-item @click="$refs.updatePwdRef.toggleVisible()">
              {{ $t("headerModules.upPassword") }}
            </el-dropdown-item>
            <el-dropdown-item @click="handleLogout">
              {{ $t("headerModules.loginQuit") }}</el-dropdown-item
            >
          </el-dropdown-menu>
        </template>
      </el-dropdown>
      <UpdatePwd ref="updatePwdRef" />
    </el-space>
  </el-row>
</template>

<script setup>
import UpdatePwd from "./update-pwd";
import { deleteFile, getFileDownList } from "@/api/common";
import { getLsUserInfo, onGoLoginPage } from "@/core/storage/ls";
import { computed, nextTick, onMounted, ref } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { useRouter } from "vue-router";
import { useSysHeaderNoticeNumber, useSysHeaderToDoListNumber } from "@/hooks";
import { CaretBottom, Warning } from "@element-plus/icons-vue";
import { $t, setLanguage } from "@/i18n";
import { getCollectionApi, getCollectionDetailApi } from "@/api/mct-manager";
import { getRegisterDetails } from "@/api/application-management";
import { QINGO_PAYMENT_TYPE } from "@/views/application-management/qingo-llc/constants";

const { sysNoticeLogNumber } = useSysHeaderNoticeNumber();
const { sysToDoListNumber } = useSysHeaderToDoListNumber();
const visible = ref(false),
  columns = [
    {
      prop: "name",
      label: $t("download.name"),
      showOverflowTooltip: true,
    },
    {
      prop: "status",
      minWidth: 100,
      label: $t("download.status"),
      scopedSlots: "status",
    },
    {
      prop: "create_time",
      label: $t("common.createTime"),
      formatter: (row, column, text) =>
        text.includes("1972") || !text ? "--" : text,
      width: 180,
    },
    {
      prop: "operation",
      minWidth: 100,
      label: $t("common.operator"),
      scopedSlots: "operation",
    },
  ];

const currentObj = ref({})

const router = useRouter();
const tableRef = ref();
const fullscreenLoading = ref(false);
const receiveTypeOneObj = ref({});
const receiveTypeTwoObj = ref({});



const userInfo = computed(() => {
  return getLsUserInfo();
});

onMounted(async () => {
  getDetail()
});

async function getDetail() {
  const { result } = await getCollectionApi();
  if(result) {
    receiveTypeOneObj.value = result.data.find((item) => item.receive_type === 1) || {};
    receiveTypeTwoObj.value = result.data.find((item) => item.receive_type === 2) || {};
  }
}


async function changeLang(lang) {
  fullscreenLoading.value = true;
  await setLanguage(lang);
  window.location.reload(true);
}

function PaxClick() {
  if(receiveTypeOneObj.value.apply_status === 9) {
    router.push(`/infeed-manager/pax-add?id=${receiveTypeOneObj.value.id}`);
  }
  if(receiveTypeOneObj.value.apply_status === undefined) {
    router.push(`/infeed-manager/pax-add`);
  }
  if([0,1,2].includes(receiveTypeOneObj.value.apply_status)) {
    router.push(`/infeed-manager/pax-detail?id=${receiveTypeOneObj.value.id}`);
  }
}

function CollectionClick() {
  // if(receiveTypeTwoObj.value.receive_type === 2) {
  //   router.push("/infeed-manager/collection-detail");
  //   return
  // }
  // router.push("/infeed-manager/collection-add");
  // if(receiveTypeTwoObj.value.apply_status === 9) {
  //   router.push(`/infeed-manager/collection-add?id=${receiveTypeTwoObj.value.id}`);
  // }
  // if(receiveTypeTwoObj.value.apply_status === undefined) {
  //   router.push(`/infeed-manager/collection-add`);
  // }
  // if([0,1,2].includes(receiveTypeTwoObj.value.apply_status)) {
  //   router.push(`/infeed-manager/collection-detail?id=${receiveTypeTwoObj.value.id}`);
  // }
  router.push('/expense-center/import-subscription')
}

const isDealer = computed(() => {
  const { mct_type, biz_type } = getLsUserInfo();
  return mct_type !== 3 || biz_type === 3;
});

//跳转收款商户号申请页面
const applyMerchant = (url) => {
  router.push(url);
};

// 进件管理：代收(biz_type=2)直接跳代收(qingo)新增/详情，参考 mctapp；自收走类型选择页
const goApplicationManagement = async () => {
  const { biz_type } = getLsUserInfo() || {};
  if (biz_type === 2) {
    try {
      const { result, error } = await getRegisterDetails({
        payment_type: QINGO_PAYMENT_TYPE,
        receive_type: 2,
      });
      if (error) {
        ElMessage.error(error.msg || "加载失败");
        return;
      }
      const status = result?.status;
      // status: 0 未通过; 1 待确认; 2 已入驻; 3 驳回; 4 h5端审核通过; 9 草稿
      if ([1, 2, 3, 4].includes(status)) {
        router.push(
          `/expense-center/application-management/qingo-llc/qingo-detail?payment_type=${QINGO_PAYMENT_TYPE}`
        );
      } else if (status === undefined || status === 9) {
        router.push(
          `/expense-center/application-management/qingo-llc/qingo-add?payment_type=${QINGO_PAYMENT_TYPE}`
        );
      } else {
        ElMessage.error(error?.msg || "加载失败");
      }
    } catch (e) {
      console.error(e);
      ElMessage.error("加载失败");
    }
    return;
  }
  // 自收或未知类型：保持原行为，进类型选择页
  router.push("/expense-center/application-management/index");
};

function handleLogout(e) {
  ElMessageBox.confirm(
    $t("userModules.login.noticeInfo"),
    $t("common.Notice"),
    {
      confirmButtonText: $t("commonComponents.ConfirmText"),
      cancelButtonText: $t("commonComponents.cancelText"),
      showCancelButton: true,
      // type: "warning",
    },
  )
    .then(() => {
      onGoLoginPage();
    })
    .catch(() => {});
}

function getList(params) {
  return getFileDownList(params);
}

function toNotice() {
  router.push("/sys-notice");
}

//待办事项
function goToDoList() {
  router.push("/to-do-list");
}

function visibleChange(e) {
  if(e) {
    getDetail()
  }
}

async function downloadClick() {
  visible.value = !visible.value;
  await nextTick();
  tableRef.value.refresh();
}

async function downloadFile(record) {
  try {
    // 使用 fetch 获取文件内容，然后创建 blob 下载
    const response = await fetch(record.file_url);
    if (!response.ok) {
      throw new Error('Download failed');
    }
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    
    const a = document.createElement('a');
    a.href = url;
    a.download = record.name;
    document.body.appendChild(a);
    a.click();
    
    // 清理
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    // 降级方案：如果 fetch 失败，使用原方式打开
    const a = document.createElement('a');
    a.href = record.file_url;
    a.target = '_blank';
    a.click();
  }
}

async function deleteClick(record) {
  const { result } = await deleteFile(record.id);
  if (result) {
    tableRef.value.refresh();
  }
}
</script>

<style lang="scss" scoped>
.el-tooltip__trigger:first-child:focus-visible {
  outline: unset;
}
.ant-pro-drop-down {
  .overlayClassName {
    margin-right: 20px;
  }
}

.inform {
  position: relative;
  padding-right: 10px;
  cursor: pointer;
  margin-right: 20px;

  .informNumber {
    position: absolute;
    top: -50%;
    left: 65%;
    background-color: red;
    height: 15px;
    min-width: 20px;
    line-height: 15px;
    text-align: center;
    color: #fff;
    border-radius: 8px;
  }
}

.search-input {
  width: 200px;
  height: 32px;
  margin-right: 40px;

  :deep(.el-input__wrapper) {
    border-radius: 17px;
  }
}
</style>
